export default __webpack_public_path__ + "static/media/undraw_Empty.f5635653.svg";